import { IconButton, ProductLockup } from '@fruuit/ui'
import { ArrowUpRight, Menu as MenuIcon } from 'lucide-react'
import { Link } from 'react-router'
import type { AreaId } from '../api/types'
import { AREAS, orgLabel } from '../areas/areas'
import { useSession } from '../auth/session-context'
import { AreaSwitcher } from './AreaSwitcher'
import { UserMenu } from './UserMenu'

export function TopBar({ area, onOpenNav }: { area: AreaId; onOpenNav: () => void }) {
  const me = useSession()
  return (
    <header className="sticky top-0 z-40 border-b border-line bg-surface/95 backdrop-blur-sm">
      <div className="flex h-16 items-center gap-2 px-3 sm:gap-3 sm:px-6">
        <IconButton
          label="Open navigation"
          icon={<MenuIcon />}
          onClick={onOpenNav}
          className="lg:hidden"
        />
        <Link
          to={AREAS[area].basePath}
          className="flex shrink-0 items-center rounded-md no-underline"
        >
          {/* Named by its visible text (WCAG 2.5.3 label in name), plus "home" for AT. */}
          <span className="hidden sm:contents">
            <ProductLockup />
          </span>
          <span className="contents sm:hidden">
            <ProductLockup compact />
          </span>
          <span className="sr-only">, home</span>
        </Link>
        <AreaSwitcher current={area} className="ml-3 hidden border-l border-line pl-5 md:block" />

        <div className="ml-auto flex items-center gap-1 sm:gap-3">
          <div className="hidden text-right leading-tight lg:block">
            <p className="text-[13px] font-semibold text-ink">{orgLabel(me, area)}</p>
            <p className="mt-0.5 flex items-center justify-end gap-1.5 text-xs text-sage">
              <span aria-hidden="true" className="size-1.5 rounded-full bg-[#88a66a]" />
              Private workspace
            </p>
          </div>
          {area === 'app' ? (
            <Link
              to="/app/requests"
              className="hidden items-center gap-1 rounded-md px-2.5 py-1.5 text-[13px] font-semibold text-teal no-underline hover:bg-wash md:inline-flex"
            >
              Requests
              <ArrowUpRight aria-hidden="true" className="size-3.5" />
            </Link>
          ) : null}
          <span aria-hidden="true" className="hidden h-7 w-px bg-line lg:block" />
          <UserMenu />
        </div>
      </div>
    </header>
  )
}
